module.exports = __webpack_public_path__ + "static/media/bo.5320b676.jpg";